import { object, string } from 'yup'

const newsletterSubscription = object().shape({
    email: string()
        .email()
        .required()
})

export { newsletterSubscription }
